$('.main--button').on('click', function() {
    $(function(){
        //下のtextの中の""の中身を入れ替える。
        $("#secondTitle").text("カードをシャッフルしています")
        $(".main--button").css({opacity:0})
        $(".main--button").css("z-index","-1")
        $(".main--firstImg").css("left","400px")
        $(".main--button").css("z-index","-10")
        $(".main--overlay").css("z-index","100")

        function rotate() {
            $('ul.delay-show li').css({opacity:0}).each(function(i){
                $(this).delay(50*i).animate({opacity:1}, 300);
            });
            var item_num = $('ul.delay-show li').length;
            var deg = 360.0/item_num;
            var red = (deg*Math.PI/180.0);
            var circle_r = $("ul.delay-show li").width() * 2.5;
            $('ul.delay-show li').each(function(i, elem) {
                var x = Math.cos(red * i) * circle_r + circle_r;
                var y = Math.sin(red * i) * circle_r + circle_r;
                $(elem).css('left', x);
                $(elem).css('top', y);
                $(elem).css('transform','translate(-50%,-50%)')
            });
        }

        setTimeout(function() {
            $(".main--firstImg").css("opacity","0")
            rotate();
        },1000)
        
        setTimeout(function(){
            var arr = $('ul.delay-show li');
            var a = arr.length;
            //シャッフルアルゴリズム
            while (a) {
                var j = Math.floor(Math.random() * a);
                var t = arr[--a];
                arr[a] = arr[j];
                arr[j] = t;
            }
            var parent = $('ul.delay-show')
            //シャッフルされた配列の要素を順番に表示する
            $.each(arr, function (index) {
                arr.eq(index).delay(50*index).animate({'left':'200px', 'top':'200px','z-index':index}, 300);
            });
        },6000)

        setTimeout(function(){
            var arr = $('ul.delay-show li');
            var container = $('ul.delay-show')
            arr.each(function(index) {
                arr.eq(arr.eq(index).css('z-index')).prependTo(container);
            });
            var arr2 = $('ul.delay-show li');
            //シャッフルされた配列の要素を順番に表示する
            $.each(arr2, function (index) {
                number = index % 9
                switch(number){
                    case 0:
                        arr2.eq(index).delay(50*index).animate({'left':'0px', 'top':'0px','z-index':index}, 300);
                        break;
                    case 1:
                        arr2.eq(index).delay(50*index).animate({'left':'200px', 'top':'0px','z-index':index}, 300);
                        break;
                    case 2:
                        arr2.eq(index).delay(50*index).animate({'left':'400px', 'top':'0px','z-index':index}, 300);
                        break;
                    case 3:
                        arr2.eq(index).delay(50*index).animate({'left':'0px', 'top':'200px','z-index':index}, 300);
                        break;
                    case 4:
                        arr2.eq(index).delay(50*index).animate({'left':'200px', 'top':'200px','z-index':index}, 300);
                        break;
                    case 5:
                        arr2.eq(index).delay(50*index).animate({'left':'400px', 'top':'200px','z-index':index}, 300);
                        break;
                    case 6:
                        arr2.eq(index).delay(50*index).animate({'left':'0px', 'top':'400px','z-index':index}, 300);
                        break;
                    case 7:
                        arr2.eq(index).delay(50*index).animate({'left':'200px', 'top':'400px','z-index':index}, 300);
                        break;
                    case 8:
                        arr2.eq(index).delay(50*index).animate({'left':'400px', 'top':'400px','z-index':index}, 300);
                        break;
                }
            });
        },11000)

        setTimeout(function(){
            $(".main--overlay").css("z-index","-1")
            //下のtextの中の""の中身を入れ替える。
             $("#secondTitle").text("好きなカードを選んでください")
        },15000)
    });
})


var isBack = true;
$('ul.delay-show li').on('click', function(e) {
    e.preventDefault();
    var flg = $(this).children('.open_flg');
    var cardNum = $(this).index();
    var elementHref = $(this).children('a').attr("href");
    if(isBack == true){
        flg.addClass('close_flg').removeClass('open_flg');
        flg.find('.i1').addClass('ani1_1').removeClass('ani2_1');
        flg.find('.i2').addClass('ani1_2').removeClass('ani2_2');
        flg.css('transform','scale(3,3)');
        $(this).animate({'left':'200px', 'top':'200px'}, 400);
        $(this).css('z-index', '9999',);
        isBack = false;
    }
    setTimeout(function(){
        window.location.href = elementHref;
    }, 3000);
});